import request from "@utils/request";

export function getLoginSummary(query) {
    return request({
        url: "login/summary",
        method: "get",
        params: query
    });
}
